<template>
    <Admin
        :title="__('Gallery', null, $page.props.profile_locale)"
    >
    <div class="relative">
        <ImageUpload
            :label="__('Add new images', null, $page.props.profile_locale)"
            @images-uploaded="saveForm"
            :images="gallery ? gallery.value : []"
            :multiple="true"
            :spinner="false"
            class="mb-6"
            type="gallery"
        >
        <template #top="{ data }">
            <p v-if="data && data.length" class="text-gray-900 font-bold text-sm">Przeciągnij aby zmienić kolejność</p>
        </template>
        </ImageUpload>

        <div class="absolute inset-0 bg-gray-200 bg-opacity-50 flex justify-center items-center" v-if="loading">
            <Spinner
                class="w-10 h-10 absolute"
            />
        </div>
    </div>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import ImageUpload from 'UI/ImageUpload';
    import { Inertia } from '@inertiajs/inertia';
    import { ref } from '@vue/reactivity';
    import Spinner from 'UI/Spinner';


    export default {
        props: {
            gallery: [Array, Object],
        },
        components: {
            Admin,
            Spinner,
            ImageUpload,
        },
        setup(props) {
            const loading = ref(false);
            function saveForm(ev) {
                loading.value = true;

                Inertia.post(route('admin.gallery.update'), {
                    gallery: ev,
                },
                {
                    preserveScroll: true,
                    onSuccess: () => { loading.value = false },
                })
            }
            return {
                saveForm,
                loading,
            }
        },

    }
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}
</style>
